// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "button.btn.transparent.purple{background-color:rgba(100,16,108,.1);color:#64106c}", "",{"version":3,"sources":["webpack://./resources/js/components/atoms/Button/style.scss"],"names":[],"mappings":"AAAA,8BAA8B,oCAAoC,CAAC,aAAa","sourcesContent":["button.btn.transparent.purple{background-color:rgba(100,16,108,.1);color:#64106c}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
